export default class CustomerRepository {
    getCustomerData() {
        return $.get(`${window.env.baseUrl}/user/current`);
    }
}
